import React, {useEffect,useState} from "react";
import PropTypes from 'prop-types';

const ProductImage = ({ photo, photoAlt, styles }) => {
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        if (photo) {
            const image = new Image();
            image.src = photo;
            image.onload = () => {
                setHasError(false);
            };
            image.onerror = () => {
                setHasError(true);
            };
        } else {
            setHasError(true);
        }
    }, [photo]);

    return (
        <span className={'product-item-image'}>
            {hasError ? (
                <span className="errorImage">Image Coming Soon</span>
            ) : (
                <img src={photo} alt={photoAlt} className={styles} />
            )}
        </span>
    );
};

ProductImage.propTypes = {
    photo: PropTypes.string,
    photoAlt: PropTypes.string,
    styles:PropTypes.string
};

export default ProductImage;